import weightIcon from '../../../assets/weightIcon.png'
import valorIcon from '../../../assets/valorIcon.png'
import postalIcon from '../../../assets/postalIcon.png'

interface CriteriaConfiguration {
    id: number
    value: string
    operator: string
    first_value: string | null
    second_value: string | null
}

interface Props {
    id: number
    name: string
    valueKey: 'weight' | 'declared_value' | 'postal_code_range'
    criteria_configurations: CriteriaConfiguration
}

export const RangeCriteriaDetail = ({
    name,
    valueKey,
    criteria_configurations,
}: Props) => {
    const criteriaIcons = {
        weight: weightIcon,
        declared_value: valorIcon,
        postal_code_range: postalIcon,
    }

    const renderValues = () => {
        const { operator, first_value, second_value } = criteria_configurations

        switch (operator) {
            case '=':
                return <span>= {first_value || second_value || 'N/A'}</span>

            case 'between':
                return (
                    <span>
                        {first_value || 'N/A'} a {second_value || 'N/A'}
                    </span>
                )

            case '>=':
            case '>':
                return (
                    <span>
                        {operator} {first_value || 'N/A'}
                    </span>
                )

            case '<=':
            case '<':
                return (
                    <span>
                        {operator} {second_value || 'N/A'}
                    </span>
                )

            default:
                return (
                    <span>
                        {first_value || ''}{' '}
                        {second_value ? `- ${second_value}` : ''}
                    </span>
                )
        }
    }

    const getUnit = () => {
        switch (valueKey) {
            case 'weight':
                return 'kg '
            case 'declared_value':
                return '$ '
            default:
                return ''
        }
    }

    const unit = getUnit()

    return (
        <div className="flex items-center mb-2">
            <img src={criteriaIcons[valueKey]} alt={`${name} icon`} />
            <h3 className="text-[#141A1F] text-[14px] font-normal ml-2 ">
                {name}:
                <span className="ml-2  bg-[#F1F5F9] text-[#3E5060] rounded px-2 py-1 text-sm">
                    {renderValues()}
                    {unit}
                </span>
            </h3>
        </div>
    )
}
